import { render, staticRenderFns } from "./TakipHazirlaOptions.vue?vue&type=template&id=c1c21d4a&scoped=true"
import script from "./TakipHazirlaOptions.vue?vue&type=script&lang=ts"
export * from "./TakipHazirlaOptions.vue?vue&type=script&lang=ts"
import style0 from "./TakipHazirlaOptions.vue?vue&type=style&index=0&id=c1c21d4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c21d4a",
  null
  
)

export default component.exports